<div class="page center">
  <div class="login-card">
    <div class="eyebrow">Email verification</div>
    <h1>Verification</h1>
    <p>{{ message }}</p>
    <div class="small"><a class="link" routerLink="/login">Go to login</a></div>
  </div>
</div>
